document.addEventListener('DOMContentLoaded', function() {
  // 1. Mapping harga manual
  const priceMap = {
    // Keyboard
    'template--23605029536022__main-1-0': 'Rp 449.000', // APOLLO61 Lite
    'template--23605029536022__main-1-1': 'Rp 499.000', // APOLLO61 Lite Clear White
    'template--23605029536022__main-1-2': 'Rp 789.000', // VOYAGER68 v2 Milky Purple
    'template--23605029536022__main-1-3': 'Rp 789.000', // VOYAGER68 v2 Smokey Black
    'template--23605029536022__main-1-4': 'Rp 889.000', // Rover84 Black
    'template--23605029536022__main-1-5': 'Rp 889.000', // Rover84 Red
    'template--23605029536022__main-1-6': 'Rp 1.489.000', // Rover84 Lightyear Stardust White
    'template--23605029536022__main-1-7': 'Rp 549.000', // Essential75 Smokey
    'template--23605029536022__main-1-8': 'Rp 549.000', // Essential75 Clear White
    'template--23605029536022__main-1-9': 'Rp 749.000', // Essential75W Clear White Wireless

    // Keycap
    'template--23605029536022__main-2-0': 'Rp 0', // Basic Keycaps
    'template--23605029536022__main-2-1': 'Rp 299.000',  // PPBT Harajuku
    'template--23605029536022__main-2-2': 'Rp 349.000', // PPBT Shibuya
    'template--23605029536022__main-2-3': 'Rp 349.000',  // PPBT Matcha
    'template--23605029536022__main-2-4': 'Rp 349.000',  // PPBT Ube
    'template--23605029536022__main-2-5': 'Rp 299.000', // PPBT Brighton
    'template--23605029536022__main-2-6': 'Rp 349.000', // PPBT Cosmonaut
    'template--23605029536022__main-2-7': 'Rp 349.000', // PPBT Shirakawa
    'template--23605029536022__main-2-8': 'Rp 299.000', // PPBT Vintage Korean
    'template--23605029536022__main-2-9': 'Rp 299.000', // PPBT Rover
    'template--23605029536022__main-2-10': 'Rp 349.000', // PPTB RES
    'template--23605029536022__main-2-11': 'Rp 499.000', // PPTB Giyu
    'template--23605029536022__main-2-12': 'Rp 499.000', // PPTB Shinobu

  };

  // 2. Konfigurasi variant
  const variantConfig = {
    'Keyboard': {
      imgTarget: 'img-keyboard-yc',
      txtTarget: 'txt-keyboard-yc',
      priceTarget: 'harga-keyboard-yc-id',
      classPrefix: 'custom-keyboard-'
    },
    'Keycap': {
      imgTarget: 'img-keycaps-yc',
      txtTarget: 'txt-keycaps-yc',
      priceTarget: 'harga-keycaps-yc-id',
      classPrefix: 'custom-keycap-'
    }
  };

  // 3. Fungsi untuk mengambil konten ::before
  function getBeforeContent(className) {
    const dummy = document.createElement('div');
    dummy.className = className;
    dummy.style.visibility = 'hidden';
    document.body.appendChild(dummy);
    const content = window.getComputedStyle(dummy, '::before').getPropertyValue('content') || '';
    document.body.removeChild(dummy);
    return content.replace(/^["'](.*)["']$/, '$1');
  }

  // 4. Event listener untuk semua radio button
  document.querySelectorAll('input[type=radio][name="Keyboard"], input[type=radio][name="Keycap"]').forEach(radio => {
    radio.addEventListener('change', function(e) {
      const variantGroup = e.target.name;
      const config = variantConfig[variantGroup];
      
      const label = document.querySelector(`label[for="${CSS.escape(e.target.id)}"]`);
      if (!label) return;

      const classList = Array.from(label.classList).find(cls => cls.startsWith(config.classPrefix));
      
      if (classList) {
        // Update gambar
        const imgDummy = document.createElement('div');
        imgDummy.className = classList;
        document.body.appendChild(imgDummy);
        const bgImage = window.getComputedStyle(imgDummy).backgroundImage;
        const imageUrl = bgImage.match(/url\(["']?(.*?)["']?\)/)?.[1] || '';
        document.body.removeChild(imgDummy);
        
        if (imageUrl) {
          document.getElementById(config.imgTarget).src = imageUrl;
        }

        // Update text
        const textContent = getBeforeContent(classList);
        const targetElement = document.getElementById(config.txtTarget);
        if (textContent && targetElement) {
          targetElement.textContent = textContent;
        }

        // Update harga
        const priceElement = document.getElementById(config.priceTarget);
        if (priceElement && priceMap[e.target.id]) {
          priceElement.textContent = priceMap[e.target.id];
        }
      }
    });
  });

  // 5. Inisialisasi nilai default
  function initDefaultValues() {
    // Keyboard default
    const defaultKeyboard = document.querySelector('input[name="Keyboard"]:checked');
    if (defaultKeyboard) {
      const label = document.querySelector(`label[for="${CSS.escape(defaultKeyboard.id)}"]`);
      if (label) {
        const classList = Array.from(label.classList).find(cls => cls.startsWith('custom-keyboard-'));
        if (classList) {
          // Update gambar
          const imgDummy = document.createElement('div');
          imgDummy.className = classList;
          document.body.appendChild(imgDummy);
          const bgImage = window.getComputedStyle(imgDummy).backgroundImage;
          const imageUrl = bgImage.match(/url\(["']?(.*?)["']?\)/)?.[1] || '';
          document.body.removeChild(imgDummy);
          document.getElementById('img-keyboard-yc').src = imageUrl;

          // Update text
          const textContent = getBeforeContent(classList);
          document.getElementById('txt-keyboard-yc').textContent = textContent;

          // Update harga
          if (priceMap[defaultKeyboard.id]) {
            document.getElementById('harga-keyboard-yc-id').textContent = priceMap[defaultKeyboard.id];
          }
        }
      }
    }

    // Keycap default
    const defaultKeycap = document.querySelector('input[name="Keycap"]:checked');
    if (defaultKeycap) {
      const label = document.querySelector(`label[for="${CSS.escape(defaultKeycap.id)}"]`);
      if (label) {
        const classList = Array.from(label.classList).find(cls => cls.startsWith('custom-keycap-'));
        if (classList) {
          // Update gambar
          const imgDummy = document.createElement('div');
          imgDummy.className = classList;
          document.body.appendChild(imgDummy);
          const bgImage = window.getComputedStyle(imgDummy).backgroundImage;
          const imageUrl = bgImage.match(/url\(["']?(.*?)["']?\)/)?.[1] || '';
          document.body.removeChild(imgDummy);
          document.getElementById('img-keycaps-yc').src = imageUrl;

          // Update text
          const textContent = getBeforeContent(classList);
          document.getElementById('txt-keycaps-yc').textContent = textContent;

          // Update harga
          if (priceMap[defaultKeycap.id]) {
            document.getElementById('harga-keycaps-yc-id').textContent = priceMap[defaultKeycap.id];
          }
        }
      }
    }
  }

  initDefaultValues();
});

document.addEventListener('DOMContentLoaded', function() {
  // Mapping lengkap untuk audio dan harga random
  const combinationMap = {
    'template--23605029536022__main-1-0|Switch Stock': {
      audio: '',
      price: 'Rp '
    },
    'template--23605029536022__main-1-0|Switch Ivory Linear': {
      audio: 'https://indonesia-care.org/demo/sound-keyboard/Apollo61-Lite/Apollo61-Lite-Azurite.MP3',
      price: 'Rp 188.490'
    },
    'template--23605029536022__main-1-0|Switch Salmon Tactile': {
      audio: 'https://indonesia-care.org/demo/sound-keyboard/Apollo61-Lite/Apollo61-Lite-Salmon.MP3',
      price: 'Rp 188.490'
    },
    'template--23605029536022__main-1-0|Switch Jupiter Tactile': {
      audio: 'https://indonesia-care.org/demo/sound-keyboard/Apollo61-Lite/Apollo61-Lite-Jupiter.MP3',
      price: 'Rp 261.690'
    },
    'template--23605029536022__main-1-0|Switch Neptune Linear': {
      audio: 'https://indonesia-care.org/demo/sound-keyboard/Apollo61-Lite/Apollo61-Lite-Neptune.MP3',
      price: 'Rp 261.690'
    },
    'template--23605029536022__main-1-0|Switch Vaporwave Tactile': {
      audio: 'https://indonesia-care.org/demo/sound-keyboard/Apollo61-Lite/Apollo61-Lite-Vaporwave.MP3',
      price: 'Rp 365.390'
    },
    'template--23605029536022__main-1-0|Switch Pressplay x Crankytech Azurite Linear': {
      audio: 'https://indonesia-care.org/demo/sound-keyboard/Apollo61-Lite/Apollo61-Lite-Azurite.MP3',
      price: 'Rp 365.390'
    },

    // Template 1-1
    'template--23605029536022__main-1-1|Switch Stock': {
      audio: '',
      price: 'Rp '
    },
    'template--23605029536022__main-1-1|Switch Ivory Linear': {
      audio: 'https://indonesia-care.org/demo/sound-keyboard/Apollo61-Lite/Apollo61-Lite-Azurite.MP3',
      price: 'Rp 188.490'
    },
    'template--23605029536022__main-1-1|Switch Salmon Tactile': {
      audio: 'https://indonesia-care.org/demo/sound-keyboard/Apollo61-Lite/Apollo61-Lite-Salmon.MP3',
      price: 'Rp 188.490'
    },
    'template--23605029536022__main-1-1|Switch Jupiter Tactile': {
      audio: 'https://indonesia-care.org/demo/sound-keyboard/Apollo61-Lite/Apollo61-Lite-Jupiter.MP3',
      price: 'Rp 261.690'
    },
    'template--23605029536022__main-1-1|Switch Neptune Linear': {
      audio: 'https://indonesia-care.org/demo/sound-keyboard/Apollo61-Lite/Apollo61-Lite-Neptune.MP3',
      price: 'Rp 261.690'
    },
    'template--23605029536022__main-1-1|Switch Vaporwave Tactile': {
      audio: 'https://indonesia-care.org/demo/sound-keyboard/Apollo61-Lite/Apollo61-Lite-Vaporwave.MP3',
      price: 'Rp 365.390'
    },
    'template--23605029536022__main-1-1|Switch Pressplay x Crankytech Azurite Linear': {
      audio: 'https://indonesia-care.org/demo/sound-keyboard/Apollo61-Lite/Apollo61-Lite-Azurite.MP3',
      price: 'Rp 365.390'
    },

    
    // ... (dan seterusnya untuk semua kombinasi)


    'template--23605029536022__main-1-2|Switch Stock': {
      audio: '',
      price: 'Rp '
    },
    'template--23605029536022__main-1-2|Switch Ivory Linear': {
      audio: 'https://indonesia-care.org/demo/sound-keyboard/Voyager68-V2/Voyager68-V2-ivory-White.MP3',
      price: 'Rp 207.300'
    },
    'template--23605029536022__main-1-2|Switch Salmon Tactile': {
      audio: 'https://indonesia-care.org/demo/sound-keyboard/Voyager68-V2/Voyager68-V2-Salmon.MP3',
      price: 'Rp 207.300'
    },
    'template--23605029536022__main-1-2|Switch Jupiter Tactile': {
      audio: 'https://indonesia-care.org/demo/sound-keyboard/Voyager68-V2/Voyager68-V2-Jupiter.MP3',
      price: 'Rp 287.430'
    },
    'template--23605029536022__main-1-2|Switch Neptune Linear': {
      audio: 'https://indonesia-care.org/demo/sound-keyboard/Voyager68-V2/Voyager68-V2-Neptune.MP3',
      price: 'Rp 287.430'
    },
    'template--23605029536022__main-1-2|Switch Vaporwave Tactile': {
      audio: 'https://indonesia-care.org/demo/sound-keyboard/Voyager68-V2/Voyager68-V2-Vaporwave.MP3',
      price: 'Rp 401.330'
    },
    'template--23605029536022__main-1-2|Switch Pressplay x Crankytech Azurite Linear': {
      audio: 'https://indonesia-care.org/demo/sound-keyboard/Voyager68-V2/Voyager68-V2-Azurite.MP3',
      price: 'Rp 401.330'
    },


    //Voyager

    'template--23605029536022__main-1-3|Switch Stock': {
      audio: '',
      price: 'Rp '
    },
    'template--23605029536022__main-1-3|Switch Ivory Linear': {
      audio: 'https://indonesia-care.org/demo/sound-keyboard/Voyager68-V2/Voyager68-V2-ivory-White.MP3',
      price: 'Rp 207.300'
    },
    'template--23605029536022__main-1-3|Switch Salmon Tactile': {
      audio: 'https://indonesia-care.org/demo/sound-keyboard/Voyager68-V2/Voyager68-V2-Salmon.MP3',
      price: 'Rp 207.300'
    },
    'template--23605029536022__main-1-3|Switch Jupiter Tactile': {
      audio: 'https://indonesia-care.org/demo/sound-keyboard/Voyager68-V2/Voyager68-V2-Jupiter.MP3',
      price: 'Rp 287.430'
    },
    'template--23605029536022__main-1-3|Switch Neptune Linear': {
      audio: 'https://indonesia-care.org/demo/sound-keyboard/Voyager68-V2/Voyager68-V2-Neptune.MP3',
      price: 'Rp 287.430'
    },
    'template--23605029536022__main-1-3|Switch Vaporwave Tactile': {
      audio: 'https://indonesia-care.org/demo/sound-keyboard/Voyager68-V2/Voyager68-V2-Vaporwave.MP3',
      price: 'Rp 401.330'
    },
    'template--23605029536022__main-1-3|Switch Pressplay x Crankytech Azurite Linear': {
      audio: 'https://indonesia-care.org/demo/sound-keyboard/Voyager68-V2/Voyager68-V2-Azurite.MP3',
      price: 'Rp 401.330'
    },


    // ROver 84

    'template--23605029536022__main-1-4|Switch Stock': {
  audio: '',
  price: 'Rp '
},
'template--23605029536022__main-1-4|Switch Ivory Linear': {
  audio: 'https://indonesia-care.org/demo/sound-keyboard/Rover84-V4/Rover84-V4-Ivory-White.MP3',
  price: 'Rp 250.290'
},
'template--23605029536022__main-1-4|Switch Salmon Tactile': {
  audio: 'https://indonesia-care.org/demo/sound-keyboard/Rover84-V4/Rover84-V4-Salmon.MP3',
  price: 'Rp 250.290'
},
'template--23605029536022__main-1-4|Switch Jupiter Tactile': {
  audio: 'https://indonesia-care.org/demo/sound-keyboard/Rover84-V4/Rover84-V4-Jupiter.MP3',
  price: 'Rp 347.490'
},
'template--23605029536022__main-1-4|Switch Neptune Linear': {
  audio: 'https://indonesia-care.org/demo/sound-keyboard/Rover84-V4/Rover84-V4-Neptune.MP3',
  price: 'Rp 347.490'
},
'template--23605029536022__main-1-4|Switch Vaporwave Tactile': {
  audio: 'https://indonesia-care.org/demo/sound-keyboard/Rover84-V4/Rover84-V4-Vaporwave.MP3',
  price: 'Rp 485.190'
},
'template--23605029536022__main-1-4|Switch Pressplay x Crankytech Azurite Linear': {
  audio: 'https://indonesia-care.org/demo/sound-keyboard/Rover84-V4/Rover84-V4-Azurite.MP3',
  price: 'Rp 485.190'
},

// Rover 84 Red
    
    'template--23605029536022__main-1-5|Switch Stock': {
  audio: '',
  price: 'Rp '
},
'template--23605029536022__main-1-5|Switch Ivory Linear': {
  audio: 'https://indonesia-care.org/demo/sound-keyboard/Rover84-V4/Rover84-V4-Ivory-White.MP3',
  price: 'Rp 250.290'
},
'template--23605029536022__main-1-5|Switch Salmon Tactile': {
  audio: 'https://indonesia-care.org/demo/sound-keyboard/Rover84-V4/Rover84-V4-Salmon.MP3',
  price: 'Rp 250.290'
},
'template--23605029536022__main-1-5|Switch Jupiter Tactile': {
  audio: 'https://indonesia-care.org/demo/sound-keyboard/Rover84-V4/Rover84-V4-Jupiter.MP3',
  price: 'Rp 347.490'
},
'template--23605029536022__main-1-5|Switch Neptune Linear': {
  audio: 'https://indonesia-care.org/demo/sound-keyboard/Rover84-V4/Rover84-V4-Neptune.MP3',
  price: 'Rp 347.490'
},
'template--23605029536022__main-1-5|Switch Vaporwave Tactile': {
  audio: 'https://indonesia-care.org/demo/sound-keyboard/Rover84-V4/Rover84-V4-Vaporwave.MP3',
  price: 'Rp 485.190'
},
'template--23605029536022__main-1-5|Switch Pressplay x Crankytech Azurite Linear': {
  audio: 'https://indonesia-care.org/demo/sound-keyboard/Rover84-V4/Rover84-V4-Azurite.MP3',
  price: 'Rp 485.190'
},


    // Rover 84 Light Year White


    'template--23605029536022__main-1-6|Switch Stock': {
  audio: '',
  price: 'Rp '
},
'template--23605029536022__main-1-6|Switch Ivory Linear': {
  audio: 'https://indonesia-care.org/demo/sound-keyboard/Rover84-Light-Year/Rover84-Lite-Year-Ivory-White.MP3',
  price: 'Rp 250.290'
},
'template--23605029536022__main-1-6|Switch Salmon Tactile': {
  audio: 'https://indonesia-care.org/demo/sound-keyboard/Rover84-Light-Year/Rover84-Lite-Year-Salmon.MP3',
  price: 'Rp 250.290'
},
'template--23605029536022__main-1-6|Switch Jupiter Tactile': {
  audio: 'https://indonesia-care.org/demo/sound-keyboard/Rover84-Light-Year/Rover84-Lite-Year-Jupiter.MP3',
  price: 'Rp 347.490'
},
'template--23605029536022__main-1-6|Switch Neptune Linear': {
  audio: 'https://indonesia-care.org/demo/sound-keyboard/Rover84-Light-Year/Rover84-Lite-Year-Neptune.MP3',
  price: 'Rp 347.490'
},
'template--23605029536022__main-1-6|Switch Vaporwave Tactile': {
  audio: 'https://indonesia-care.org/demo/sound-keyboard/Rover84-Light-Year/Rover84-Lite-Year-Vaporwave.MP3',
  price: 'Rp 485.190'
},
'template--23605029536022__main-1-6|Switch Pressplay x Crankytech Azurite Linear': {
  audio: 'https://indonesia-care.org/demo/sound-keyboard/Rover84-Light-Year/Rover84-Lite-Year-Azurite.MP3',
  price: 'Rp 485.190'
},

// Rover 84 Light Year Red

        'template--23605029536022__main-1-7|Switch Stock': {
  audio: '',
  price: 'Rp '
},
'template--23605029536022__main-1-7|Switch Ivory Linear': {
  audio: 'https://indonesia-care.org/demo/sound-keyboard/Rover84-Light-Year/Rover84-Lite-Year-Ivory-White.MP3',
  price: 'Rp 250.290'
},
'template--23605029536022__main-1-7|Switch Salmon Tactile': {
  audio: 'https://indonesia-care.org/demo/sound-keyboard/Rover84-Light-Year/Rover84-Lite-Year-Salmon.MP3',
  price: 'Rp 250.290'
},
'template--23605029536022__main-1-7|Switch Jupiter Tactile': {
  audio: 'https://indonesia-care.org/demo/sound-keyboard/Rover84-Light-Year/Rover84-Lite-Year-Jupiter.MP3',
  price: 'Rp 347.490'
},
'template--23605029536022__main-1-7|Switch Neptune Linear': {
  audio: 'https://indonesia-care.org/demo/sound-keyboard/Rover84-Light-Year/Rover84-Lite-Year-Neptune.MP3',
  price: 'Rp 347.490'
},
'template--23605029536022__main-1-7|Switch Vaporwave Tactile': {
  audio: 'https://indonesia-care.org/demo/sound-keyboard/Rover84-Light-Year/Rover84-Lite-Year-Vaporwave.MP3',
  price: 'Rp 485.190'
},
'template--23605029536022__main-1-7|Switch Pressplay x Crankytech Azurite Linear': {
  audio: 'https://indonesia-care.org/demo/sound-keyboard/Rover84-Light-Year/Rover84-Lite-Year-Azurite.MP3',
  price: 'Rp 485.190'
},

    // Essential75 Smokey Black

        'template--23605029536022__main-1-8|Switch Stock': {
  audio: '',
  price: 'Rp '
},
'template--23605029536022__main-1-8|Switch Ivory Linear': {
  audio: 'https://indonesia-care.org/demo/sound-keyboard/Rover84-Light-Year/Rover84-Lite-Year-Ivory-White.MP3',
  price: 'Rp 250.290'
},
'template--23605029536022__main-1-8|Switch Salmon Tactile': {
  audio: 'https://indonesia-care.org/demo/sound-keyboard/Rover84-Light-Year/Rover84-Lite-Year-Salmon.MP3',
  price: 'Rp 250.290'
},
'template--23605029536022__main-1-8|Switch Jupiter Tactile': {
  audio: 'https://indonesia-care.org/demo/sound-keyboard/Rover84-Light-Year/Rover84-Lite-Year-Jupiter.MP3',
  price: 'Rp 347.490'
},
'template--23605029536022__main-1-8|Switch Neptune Linear': {
  audio: 'https://indonesia-care.org/demo/sound-keyboard/Rover84-Light-Year/Rover84-Lite-Year-Neptune.MP3',
  price: 'Rp 347.490'
},
'template--23605029536022__main-1-8|Switch Vaporwave Tactile': {
  audio: 'https://indonesia-care.org/demo/sound-keyboard/Rover84-Light-Year/Rover84-Lite-Year-Vaporwave.MP3',
  price: 'Rp 485.190'
},
'template--23605029536022__main-1-8|Switch Pressplay x Crankytech Azurite Linear': {
  audio: 'https://indonesia-care.org/demo/sound-keyboard/Rover84-Light-Year/Rover84-Lite-Year-Azurite.MP3',
  price: 'Rp 485.190'
},

    // Essential75 Smokey Black

        'template--23605029536022__main-1-9|Switch Stock': {
  audio: '',
  price: 'Rp '
},
'template--23605029536022__main-1-9|Switch Ivory Linear': {
  audio: 'https://indonesia-care.org/demo/sound-keyboard/Rover84-Light-Year/Rover84-Lite-Year-Ivory-White.MP3',
  price: 'Rp 250.290'
},
'template--23605029536022__main-1-9|Switch Salmon Tactile': {
  audio: 'https://indonesia-care.org/demo/sound-keyboard/Rover84-Light-Year/Rover84-Lite-Year-Salmon.MP3',
  price: 'Rp 250.290'
},
'template--23605029536022__main-1-9|Switch Jupiter Tactile': {
  audio: 'https://indonesia-care.org/demo/sound-keyboard/Rover84-Light-Year/Rover84-Lite-Year-Jupiter.MP3',
  price: 'Rp 347.490'
},
'template--23605029536022__main-1-9|Switch Neptune Linear': {
  audio: 'https://indonesia-care.org/demo/sound-keyboard/Rover84-Light-Year/Rover84-Lite-Year-Neptune.MP3',
  price: 'Rp 347.490'
},
'template--23605029536022__main-1-9|Switch Vaporwave Tactile': {
  audio: 'https://indonesia-care.org/demo/sound-keyboard/Rover84-Light-Year/Rover84-Lite-Year-Vaporwave.MP3',
  price: 'Rp 485.190'
},
'template--23605029536022__main-1-9|Switch Pressplay x Crankytech Azurite Linear': {
  audio: 'https://indonesia-care.org/demo/sound-keyboard/Rover84-Light-Year/Rover84-Lite-Year-Azurite.MP3',
  price: 'Rp 485.190'
},

    
  };

  // Elemen UI
  const audioPlayer = document.getElementById('switch-audio');
  const soundPlayerDiv = document.getElementById('switch-sound-player');
  const currentlyPlayingSpan = document.querySelector('#currently-playing span');
  const priceDisplay = document.getElementById('harga-switch-yc-id');

  // Fungsi utama untuk update audio dan harga
  function updateSelection() {
    const selectedKeyboard = document.querySelector('input[name="Keyboard"]:checked');
    const selectedSwitch = document.querySelector('input[name="properties[Switch]"]:checked');
    
    if (!selectedKeyboard || !selectedSwitch) return;
    
    const comboKey = `${selectedKeyboard.id}|${selectedSwitch.value}`;
    const combination = combinationMap[comboKey];
    
    if (combination) {
      // Update audio player
      if (combination.audio) {
        soundPlayerDiv.style.display = 'block';
        audioPlayer.src = combination.audio;
        currentlyPlayingSpan.textContent = `${selectedKeyboard.value} - ${selectedSwitch.value}`;
        
        audioPlayer.play().catch(e => {
          console.log("Autoplay prevented:", e);
          audioPlayer.controls = true;
        });
      } else {
        soundPlayerDiv.style.display = 'none';
        audioPlayer.src = '';
      }
      
      // Update harga
      if (priceDisplay) {
        priceDisplay.textContent = combination.price;
        priceDisplay.classList.add('price-updated');
        
        // Animasi perubahan harga
        priceDisplay.style.transform = 'scale(1.1)';
        setTimeout(() => {
          priceDisplay.style.transform = 'scale(1)';
        }, 300);
      }
    } else {
      soundPlayerDiv.style.display = 'none';
      audioPlayer.src = '';
      if (priceDisplay) {
        priceDisplay.textContent = 'Rp 0';
        priceDisplay.classList.remove('price-updated');
      }
    }
  }

  // Event listeners
  document.querySelectorAll('input[name="Keyboard"]').forEach(radio => {
    radio.addEventListener('change', updateSelection);
  });
  
  document.querySelectorAll('input[name="properties[Switch]"]').forEach(radio => {
    radio.addEventListener('change', updateSelection);
  });
  
  // Inisialisasi default
  updateSelection();
});

document.addEventListener('DOMContentLoaded', function() {
  const mediaWrapper = document.querySelector('.product__media-wrapper');
  
  if (mediaWrapper) {
    const observer = new IntersectionObserver(
      ([e]) => {
        mediaWrapper.classList.toggle('is-sticky', e.intersectionRatio < 1);
      },
      {threshold: [1]}
    );
    
    observer.observe(mediaWrapper);
  }
});
  document.addEventListener('DOMContentLoaded', function () {
    const switchImage = document.getElementById('img-switch-yc');
    const switchText = document.getElementById('txt-yc');

    const switchMap = {
      "Switch Stock": "https://play-lh.googleusercontent.com/Pb_eEeA0KceZGGpfohN8Tgan-80FiPi4QNbOL8mzMoKw4aAMvx6vyDDrakxVqRkarA",
      "Switch Ivory Linear": "https://pressplayid.com/cdn/shop/files/IvoryWhiteSwitch.jpg?v=1714729211&width=720",
      "Switch Salmon Tactile": "https://pressplayid.com/cdn/shop/files/SalmonSwitch.jpg?v=1714806143&width=720",
      "Switch Jupiter Tactile": "https://pressplayid.com/cdn/shop/products/4b711b69-15a8-4f39-937a-50cb7e0153fb-jupiter-switch.jpg?v=1705909687&width=720",
      "Switch Neptune Linear": "https://pressplayid.com/cdn/shop/products/848e9e0f-3a95-4f5d-b8e0-d21e6f8e6519-neptune-switch.jpg?v=1705909869&width=720",
      "Switch Vaporwave Tactile": "https://pressplayid.com/cdn/shop/products/b750bf4d-b1ea-4178-9305-ec6435d4dafe-vaporwave.jpg?v=1705913487&width=720",
      "Switch Pressplay x Crankytech Azurite Linear": "https://pressplayid.com/cdn/shop/products/8066e183-1b6a-40f5-adae-5ab2a81f3668-cover-azurite.jpg?v=1705914206&width=720"
    };

    const radioButtons = document.querySelectorAll('input[name="properties[Switch]"]');

    radioButtons.forEach(radio => {
      radio.addEventListener('change', function () {
        const selectedValue = this.value;
        if (switchMap[selectedValue]) {
          switchImage.src = switchMap[selectedValue];
          switchText.textContent = selectedValue;
        }
      });
    });
  });